"use client";

import { TeamMemberType } from "osn-participantapi-client";
import { useMyAccount } from "../my-account/hooks";
import { useMyAccountVolunteerRequests } from "./hooks";

export function useCoachStatus(enabled: boolean = true) {
  const { data: account } = useMyAccount(enabled);
  const { data: requests, isLoading } = useMyAccountVolunteerRequests(enabled);
  const hasAssignment = !!account?.currentCoachingData?.length;
  const coachRequests = requests?.items.filter(
    (request) => request.role === TeamMemberType.HeadCoach || request.role === TeamMemberType.AssistantCoach,
  );

  return {
    isCoach: hasAssignment || !!coachRequests?.length,
    isAwaitingAssignment: !hasAssignment && !!coachRequests?.some((request) => !request.assignedTeam),
    isLoading,
  };
}
